// ----------------------------------------------------------------------------
// Snippet: Cart Confirmation
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/modal/modal';
import 'snippets/mini-cart/mini-cart';

// Styles
import './_cart-confirmation.scss';
